<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M7 5.5C7 6.32843 6.32843 7 5.5 7C4.67157 7 4 6.32843 4 5.5C4 4.67157 4.67157 4 5.5 4C6.32843 4 7 4.67157 7 5.5Z" 
    stroke="currentColor" stroke-width="1.5"/>
    <path d="M16 5.5C16 6.32843 15.3284 7 14.5 7C13.6716 7 13 6.32843 13 5.5C13 4.67157 13.6716 4 14.5 4C15.3284 4 16 4.67157 16 5.5Z" 
    stroke="currentColor" stroke-width="1.5"/>
    <path d="M16 13.75C16 14.5784 15.3284 15.25 14.5 15.25C13.6716 15.25 13 14.5784 13 13.75C13 12.9216 13.6716 12.25 14.5 12.25C15.3284 12.25 16 12.9216 16 13.75Z" 
    stroke="currentColor" stroke-width="1.5"/>
    <path d="M9.25 13C9.25 14.6568 7.90686 16 6.25 16C4.59314 16 3.25 14.6568 3.25 13C3.25 11.3432 4.59314 10 6.25 10C7.90686 10 9.25 11.3432 9.25 13Z" 
    stroke="currentColor" stroke-width="1.5"/>
    <path d="M5.64941 7L5.94941 10" stroke="currentColor" stroke-width="1.5"/>
    <path d="M8.5 10.9545L13.5622 6.35254" stroke="currentColor" stroke-width="1.5"/>
    <path d="M9.25 13.2725L13 13.6133" stroke="currentColor" stroke-width="1.5"/>
  </svg>
</template>

<script>
export default {
  name: 'SocialsIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>